export * from './post-points.model';
export * from './post.model';
